import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import { Tabs, Tab, CircularProgress, Grid } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import Copyright from '../../components/common/Copyright';
import ErrorView from '../../components/common/ErrorView';
import ClientPropertiesTab from './ClientPropertiesTab';
import ClientRatesTab from './rates/ClientRatesTab';
import ClientAgentsTab from './agents/ClientAgentsTab';
import { GET_TENANT } from '../../graphql/tenant';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {
        value === index && (
          <Grid item xs={12} sm={6}>
            {children}
          </Grid>
        )
        /*<Box sx={{ p: 3 }}>{children}</Box>*/
      }
    </div>
  );
}

const PlatformClientDetails = () => {
  let { tenantId } = useParams();
  const { data, loading, error } = useQuery(GET_TENANT, {
    variables: {
      tenantId,
    },
  });

  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  if (error) {
    return <ErrorView message={error?.message || ''} />;
  }

  if (!tenantId) {
    return <div>Missing platform client id</div>;
  }

  const tenant = data?.tenant;

  return (
    <Container component="main">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 2,
          marginBottom: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {tenant && (
          <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="tabs">
                <Tab label="Client" {...a11yProps(0)} />
                <Tab label="Rates & Funding" {...a11yProps(1)} />
                <Tab label="Agents" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <ClientPropertiesTab tenant={tenant} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <ClientRatesTab />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <ClientAgentsTab currency={tenant.currency} />
            </TabPanel>
          </>
        )}
        {loading && <CircularProgress />}
      </Box>
      <Copyright />
    </Container>
  );
};

export default PlatformClientDetails;
